import localstorage from "./localstorage";
import getPrivilagesWithFallback from "./getPrivilages";
export default (
  Vue: any,
  next: any,
  modules: string,
  role: string,
  validation: boolean = true
) => {
  return async () => {
    const userrole = localstorage.getItem("role");
    if (userrole == 'Superadmin' || userrole == 'GodMode') {
      return Promise.resolve()
    }

    const privilages = Vue.store.state.HOMEPAGE.privilages;
    const status = privilages[modules];

    if (status && (status.suspend || status.terminated)) {
      const action = status.terminated ? 'terminated' : 'suspend';
      Vue.store.commit('DASHBOARD/setopendialogdonthavepermission', action);

      return Promise.reject();
    }

    // Jika user adalah creator organisasi, izinkan akses tanpa cek privilage per role.
    // Ref: https://agile.cloudeka.ai/project/service-portal-devops/task/535
    const isCreator = localstorage.getItem('is_creator') == 'true';
    if (isCreator) {
      return Promise.resolve();
    }

    const array: any = await getPrivilagesWithFallback();
    const obj = array.find((el: any) => el.name == modules);

    if (obj && !obj.editor) {
      Vue.store.commit("DASHBOARD/setopendialogdonthavepermission", true);
      return Promise.reject();
    }

    if (privilages[modules] && privilages[modules][role] == validation) {
      return Promise.resolve();
    } else {
      Vue.store.commit('DASHBOARD/setopendialogdonthavepermission', true);
      return Promise.reject();
    }
  };
};
